/* __next_internal_client_entry_do_not_use__ default auto */ import { jsx as _jsx } from "react/jsx-runtime";
import ClientHead from 'lib/client-head/ClientHead';
import client from 'lib/sitecore-client';
/**
 * Component to render `<link>` elements for Sitecore styles
 */ const SitecoreStyles = ({ layoutData, enableStyles, enableThemes })=>{
    const headLinks = client.getHeadLinks(layoutData, {
        enableStyles,
        enableThemes
    });
    if (headLinks.length === 0) {
        return null;
    }
    return /*#__PURE__*/ _jsx(ClientHead, {
        children: headLinks.map(({ rel, href })=>/*#__PURE__*/ _jsx("link", {
                rel: rel,
                href: href
            }, href))
    });
};
export default SitecoreStyles;
